export const API_BASE_URL = "https://pro.2eztracking.com/api/"; // Replace with your actual API base URL


// export const API_BASE_URL = "http://192.168.1.200:8124/api/"
